(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["media-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-media-video-toggle]');
    if (!toggle) return;

    const wrapper = toggle.closest('[data-media-video]');
    const video = wrapper && wrapper.querySelector('video');
    if (!video) return;

    document.querySelectorAll('[data-media-video] video').forEach((other) => {
      if (other !== video) other.pause();
    });
    video.play();
  });

  function syncVideoState(event) {
    const video = event.target;
    if (!video || video.tagName !== 'VIDEO') return;

    const wrapper = video.closest('[data-media-video]');
    if (wrapper) wrapper.classList.toggle('is-playing', !video.paused);
  }

  document.addEventListener('play', syncVideoState, true);
  document.addEventListener('pause', syncVideoState, true);
  document.addEventListener('ended', syncVideoState, true);
  } catch(e) { console.error(e); }
})();

})();
